import React from "react";
import styles from "./Header.module.css";

const Header = ({ selectedSubjectName }) => {
	return (
		<div className={styles.header}>
			<div className={styles.headerLeft}>
				<h2>
					<span className={styles.subjectName}>
						{selectedSubjectName || "All Subjects"}
					</span>
					<span className={styles.departmentName}>
						11th Grade - Science Department
					</span>
				</h2>
			</div>
		</div>
	);
};

export default Header;
